module.exports = __webpack_public_path__ + "media/4.cdcce266.mp3";